import {
  Component,
  ElementRef,
  Input,
  AfterViewInit,
  Renderer2,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core'
import { ClickOutsideDirective } from '@common'

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  imports: [ClickOutsideDirective],
  standalone: true,
})
export class ContextMenuComponent implements AfterViewInit {
  @Input() elementRelatedName!: string
  @Input() elementRelatedPosition!: string

  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>()

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit(): void {
    this.showContext()
  }

  showContext() {
    const related = document.getElementById(this.elementRelatedName)
    if (!related) return

    const context = this.el.nativeElement.querySelector('.context-box') as HTMLElement
    if (!context) return

    const relatedInfo = related.getBoundingClientRect()
    const contextInfo = context.getBoundingClientRect()

    let left = relatedInfo.x - contextInfo.width / 2 + relatedInfo.width / 2 + 2

    if (this.elementRelatedPosition === 'left') {
      left = relatedInfo.x - 10
    }

    this.renderer.setStyle(context, 'left', `${left}px`)

    const spaceBelow = window.innerHeight - (relatedInfo.bottom + contextInfo.height + 6)
    const spaceAbove = relatedInfo.top - (contextInfo.height + 6)

    if (spaceBelow > 0) {
      const top = relatedInfo.bottom + 6
      this.renderer.setStyle(context, 'top', `${top}px`)
    } else if (spaceAbove > 0) {
      const top = relatedInfo.top - contextInfo.height - 6
      this.renderer.setStyle(context, 'top', `${top}px`)
    } else {
      const top = relatedInfo.bottom + 6
      this.renderer.setStyle(context, 'top', `${top}px`)
    }
  }

  @HostListener('window:scroll')
  onScroll() {
    this.showContext()
  }

  closeModal() {
    this.close.emit()
  }
}
